import React from 'react'

const Navbar = () => {
  return (
    <div className='w-full px-2 bg-purple-900 flex justify-center items-center'>
      <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-3xl heading text-purplegray-100'>
        Shri Hirji Bhojraj & Sons Cutchi Visha Oshwal Jain Chhatralaya (Matunga Boarding)
      </h1>
    </div>
  )
}

export default Navbar